export const data = [
  {
    id: 1,
    team: "Iowa",
    sauce: "LemonPepper",
    description:
      "Offensive creativity. Star power. The Hawkeyes are the ultimate gateway to falling in love with women's hoops.",
    link: "https://fansided.com/2022/03/16/iowa-womens-basketball-march-madness-preview/",
    rating: 4,
  },
  {
    id: 2,
    team: "Tennessee",
    sauce: "OriginalHot",
    description:
      "The first dynasty in women's college basketball. Full of fire and spice. They're the originals for a reason.",
    link: "https://fansided.com/2022/03/16/tennessee-womens-basketball-ncaa-tournament-preview/",
    rating: 2,
  },
  {
    id: 3,
    team: "Texas",
    sauce: "BBQ",
    description:
      "Bold. Disruptive. Sweet Shooting. Rich. It's everything you love about hoops, but better.",
    link: "https://fansided.com/2022/03/16/texas-womens-basketball-ncaa-tournament-preview/",
    rating: 5,
  },
  {
    id: 4,
    team: "South Carolina",
    sauce: "Atomic",
    description:
      "The Lady Gamecocks are the spiciest team we've got. Find out for yourself.",
    link: "https://fansided.com/2022/03/16/south-carolina-womens-basketball-ncaa-tournament-preview/",
    rating: 10,
  },
  {
    id: 5,
    team: "NC State",
    sauce: "MangoHabanero",
    description: "The Wolfpack are sweet, with heat. And then some. Seriously.",
    link: "https://fansided.com/2022/03/16/nc-state-basketball-womens-ncaa-tournament-preview/",
    rating: 8,
  },
  {
    id: 6,
    team: "Kentucky",
    sauce: "Cajun",
    description:
      "A tough defense, dusted with bold shooting and a zesty transition attack.",
    link: "https://fansided.com/2022/03/16/kentucky-womens-basketball-march-madness-preview/",
    rating: 1,
  },
  {
    id: 7,
    team: "Kansas State",
    sauce: "SKQ",
    description:
      "Shot-blocking, passing, steals and crushing execution create the perfect balance of offense and defense.",
    link: "https://fansided.com/2022/03/16/kansas-state-womens-basketball-march-madness-preview/",
    rating: 1,
  },
  {
    id: 8,
    team: "Maryland",
    sauce: "LouisianaRub",
    description:
      "A high-powered offense that dominates on the glass, with a distinctly signature swagger.",
    link: "https://fansided.com/2022/03/16/maryland-womens-basketbal-ncaa-tournament-angel-reese/",
    rating: 3,
  },
  {
    id: 9,
    team: "Stanford",
    sauce: "MildGreen",
    description: "That O.G. heat, but with a flavor all their own.",
    link: "https://fansided.com/2022/03/16/stanford-womens-basketball-march-madness-preview/",
    rating: 9,
  },
  {
    id: 10,
    team: "Louisville",
    sauce: "GarlicParm",
    description:
      "Feathery shooting, bruising post-play. This team is balanced, potent and exciting.",
    link: "https://fansided.com/2022/03/16/louisville-womens-basketball-march-madness-preview/",
    rating: 7,
  },
  {
    id: 11,
    team: "Baylor",
    sauce: "Hawaiian",
    description:
      "A sweet blend of inside power balanced with a searing outside touch.",
    link: "https://fansided.com/2022/03/16/baylor-womens-basketball-ncaa-tournament-march-madnes-preview/",
    rating: 6,
  },
];
